import React, { useState, FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { CaladanLogo } from '../components/layout/CaladanLogo';
import { useAuth } from '@/hooks/useAuth';

export function Login({ title = 'Caladan Capital' }: { title?: string }) {
  const { login, isLoading, error, isAuthed } = useAuth();
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await login(password);
  };

  if (isAuthed) return <Navigate to="/" replace />;

  return (
    <div className="flex items-center justify-center min-h-screen bg-[var(--bg-base)]">
      <form onSubmit={handleSubmit} className="flex flex-col items-center gap-6 w-full max-w-[360px] px-6">
        <div className="flex items-center gap-3 mb-2">
          {title === 'Caladan Capital' && <CaladanLogo size={28} className="text-[var(--accent-primary)]" />}
          <h1 className="text-[28px] font-[600] text-[var(--text-primary)] tracking-[-0.01em]">{title}</h1>
        </div>
        <div className="w-full">
          <label htmlFor="password" className="block text-[12px] font-[400] text-[var(--text-secondary)] mb-1.5 tracking-[0.01em]">Password</label>
          <input
            id="password" type="password" value={password}
            onChange={e => setPassword(e.target.value)} autoFocus
            placeholder="Enter dashboard password"
            className="w-full px-3 py-2.5 rounded-[6px] bg-[var(--bg-inset)] border border-[var(--border-default)] text-[14px] text-[var(--text-primary)] placeholder:text-[var(--text-tertiary)] focus:outline-none focus:border-[var(--border-strong)] focus:ring-[3px] focus:ring-[var(--accent-primary)]/15 transition-colors duration-[150ms] ease-out"
          />
        </div>
        {error && <p className="text-[13px] text-[var(--accent-danger)] text-center">{error}</p>}
        <button
          type="submit" disabled={isLoading || !password}
          className="w-full py-2.5 rounded-[6px] text-[14px] font-[500] bg-[var(--accent-primary)] text-[var(--text-inverse)] hover:brightness-110 active:brightness-95 transition-all duration-[150ms] ease-out disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
